module.exports = __webpack_public_path__ + "img/Sustainability.d9220dd6.svg";